import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15
export default {
    findAll: (keywords, role, page) => {
        return new Promise((resolve, reject) => {
            const model = {
                "searchOptions": {
                    "pageIndex": page,
                    "pageSize": pageSize,
                    "keywords": keywords,
                    "role": role
                }
            }
            HTTP.post(config.apiEndpoints.usersUri.concat('find'), model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: (role, keywords) => {
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.usersUri.concat(`all/${role}?keywords=${keywords}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findUser: (userId) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.usersUri.concat(userId)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    updateUser: (user, resetPassword) => {
        return new Promise((resolve, reject) => {
            HTTP.put(config.apiEndpoints.usersUri, {user : user, resetPassword: resetPassword}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    createUser: (user, generatePassword) => {
        return new Promise((resolve, reject) => {
            HTTP.post(config.apiEndpoints.usersUri, {user: user, generatePassword: generatePassword}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    changePassword: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(config.apiEndpoints.accountUri.concat('changepassword'), model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
    // findRole: (roleId) =>{
    //     return new Promise((resolve, reject) => {
    //         HTTP.get(rolesUrl.concat(roleId)).then((response)=>{
    //             resolve(response)
    //         }, (error)=>{
    //             reject(error)
    //         })
    //     })
    // },
    // getAllRoles: () =>{
    //     return new Promise((resolve, reject) => {
    //         HTTP.get(rolesUrl).then((response)=>{
    //             resolve(response)
    //         }, (error)=>{
    //             reject(error)
    //         })
    //     })
    // },
    // findAllRoles: (keywords, page) =>{
    //     return new Promise((resolve, reject) => {
    //         const model = {
    //             "pageIndex": page,
    //             "pageSize": pageSize,
    //             "keywords": keywords
    //         }
    //         HTTP.post(rolesUrl.concat('find'), model).then((response)=>{
    //             resolve(response)
    //         }, (error)=>{
    //             reject(error)
    //         })
    //     })
    // },
    // createRole: (role) => {
    //     return new Promise((resolve, reject) => {
    //         HTTP.post(rolesUrl, role).then((response)=>{
    //             resolve(response)
    //         }, (error)=>{
    //             reject(error)
    //         })
    //     })
    // },
    // updateRole: (role) => {
    //     return new Promise((resolve, reject) => {
    //         HTTP.put(rolesUrl, role).then((response)=>{
    //             resolve(response)
    //         }, (error)=>{
    //             reject(error)
    //         })
    //     })
    // }
}